export default __webpack_public_path__ + "static/media/Gilroy-MediumItalic.84d4545b.woff";